import notification from 'antd/lib/notification'
import 'antd/lib/notification/style/index.less'

export default notification
